import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Détection du scroll : transparent sur la 1ère section (carousel / hero),
  // fond sombre après. Le seuil s'adapte selon la page.
  useEffect(() => {
    setIsScrolled(false);
    const isHome = location.pathname === '/';
    const threshold = isHome ? window.innerHeight * 0.9 : 250;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Bloquer scroll quand menu ouvert
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/schedule', label: 'Schedule' },
    { path: '/accommodation', label: 'Accommodation' },
    { path: '/welcome-guide', label: 'Welcome Guide' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contacts', label: 'Contacts' },
    { path: '/registration', label: 'Registration' },
    { path: '/admin', label: 'Admin' }
  ];

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <h1>
            <img src="/images/logo/cisac-logo-gold-web.png" alt="CISAC 100 Years" className="logo-img" />
            <div className="logo-left">
              <span className="logo-cisac">
                <span>C</span>
                <span>I</span>
                <span>S</span>
                <span>A</span>
                <span>C</span>
              </span>
              <span className="logo-year">
                <span>2</span>
                <span>0</span>
                <span>2</span>
                <span>6</span>
              </span>
            </div>
            <div className="logo-right">
              <span className="logo-event-line1">General</span>
              <span className="logo-event-line2">Assembly</span>
              <span className="logo-event-line3">100 Years</span>
            </div>
          </h1>
        </Link>

        {/* Bouton hamburger */}
        <button
          className="hamburger-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>

        {/* Navigation avec classe conditionnelle */}
        <nav className={`nav ${isMobileMenuOpen ? 'nav-mobile-open' : ''}`}>
          {navItems.map((item) => (
            item.disabled ? (
              <span
                key={item.path}
                className={`nav-link nav-link-disabled ${
                  item.path === '/registration' ? 'nav-link-registration' : ''
                }`}
              >
                {item.label}
              </span>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''} ${
                  item.path === '/registration' ? 'nav-link-registration' : ''
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>
      </div>

      {/* Overlay pour fermer le menu */}
      {isMobileMenuOpen && (
        <div
          className="nav-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </header>
  );
}

export default Header;
